<template>
    <div></div>
</template>
<script>

    export default {
        data () {
            return {
                force_start_at: 0,
                force_end_at: 99999,
                resource: {},
                locale: null,
                locales: null,
                localesLoaded: null,
                test: null,
                options: [],
                currentRow: 0,
                totalRow: 0,
                errors: [],
                logs: [],
                fileName: null,
                dataToShow: {
                    name: 'root',
                    children: []
                },
                className:"modal-fade-enter-active",
            }
        },
        mounted: function(){

            self = this
            self.initialize();

        },
        methods:{
            fileSelected(e){
                this.currentRow = 0
                this.totalRow = 0
                this.logs = []
                let fileInput = document.getElementById( 'import' );
                this.fileName = fileInput.value.split('\\')[fileInput.value.split('\\').length-1]
            },
            upload(e){
                let fileInput = document.getElementById( 'import' );
                let data = new FormData();
                data.append( 'file', fileInput.files[0] );
                data.append( 'start_at', this.currentRow );
                data.append( 'force_start_at', this.force_start_at );
                data.append( 'force_end_at', this.force_end_at );
                this.service.import(data).then((response) => {

                    this.currentRow = response.data.current_row ? response.data.current_row : this.currentRow
                    this.totalRow = response.data.total ? response.data.total : this.totalRow

                    this.echo(response.data.log)

                    this.process(e)

                }, response => {
                    this.echo([{type:'error', name:response.data.message, status:''}])
                })
            },
            process(e){
                if( this.totalRow <= this.currentRow ){ this.$emit('refresh', this); return true; }

                let data = new FormData();
                data.append( 'start_at', this.currentRow );
                data.append( 'file_name', document.getElementById( 'import' ).files[0].name );
                data.append( 'force_start_at', this.force_start_at );
                data.append( 'force_end_at', this.force_end_at );
                this.service.import(data).then((response) => {

                    this.currentRow = response.data.current_row ? response.data.current_row : this.currentRow
                    this.totalRow = response.data.total ? response.data.total : this.totalRow

                    this.echo(response.data.log)

                    this.process(e)

                }, response => {
                    this.echo([{type:'error', name:response.data.message, status:''}])

                    // continue
                    this.currentRow = this.currentRow + 1
                    this.process(e)
                })
            },
            getResource: function(){
                return this.service
            },
            back: function(){
                self = this
                if( this.className == "" && !this.isModal ){
                    let name = self.$route.name.replace('-import', '')
                    self.$router.push({name: name});
                }
            },
            echo: function(logs){
                for(var i=0; i<logs.length ; i++){
                    this.logs.unshift(logs[i])
                }
            },
            initialize: function(){
                var self = this;
                setTimeout(function(){self.className = ""}, 100)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Import.vue